import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { RedirectingComponent } from './shared/components/redirecting/redirecting.component';
import { RoleReadyGuard } from './services/role-ready-guard.service';
import { globalSellerContextGuard } from './services/role-context.guards';
import { administrationContextGuard } from './services/administration-context.guard';

export const appRoutes: Routes = [
  {
    path: '',
    component: RedirectingComponent,
    pathMatch: 'full'
  },

  /**
   * Home
   */
  {
    path: 'home',
    loadChildren: () => import('./modules/home/home.module').then(m => m.HomePageModule)
  },

  /**
   * Login
   */
  {
    path: 'login',
    loadChildren: () => import('./modules/login/login.module').then(m => m.LoginPageModule)
  },

  /**
   * Events
   */
  {
    path: 'events',
    loadChildren: () => import('./modules/events/events.module').then(m => m.EventsPageModule)
  },

  /**
   * Scanner
   */
  {
    path: 'scanner',
    loadChildren: () => import('./modules/scanner/scanner.module').then(m => m.ScannerPageModule)
  },

  /**
   * QR status lookup (read-only, any role)
   */
  {
    path: 'qr-status',
    loadChildren: () => import('./modules/qr-status/qr-status.module').then(m => m.QrStatusPageModule)
  },

  /**
   * Reports 
   */

  {
    path: 'reports',
    loadChildren: () => import('./modules/reports/reports.module').then(m => m.ReportsModule),
  },

  /**
  *  Producer and role selection 
  */

  {
    path: 'selection',
    loadChildren: () => import('./modules/selection/selection.module').then(m => m.SelectionModule),
  },

  /**
  *  Event sales 
  */

  {
    path: 'event-sales',
    loadChildren: () =>
      import('./modules/event-sales/event-sales.module').then(
        (m) => m.EventSalesModule
      ),
  },

  /**
   * Event reports
   */

  {
    path: 'event-reports',
    loadChildren: () => import('./modules/event-reports/event-reports.module').then(m => m.EventReportsModule),
  },

  /**
   * User Profile
   */
  {
    path: 'user-profile',
    loadChildren: () => import('./modules/user-profile/user-profile.module').then(m => m.UserProfilePageModule)
  },

  /**
   * Sales Manager Home
   *
   * `RoleReadyGuard`: todo lo que cuelga de acá pide reportes acotados por rol.
   * Sin el guard, un arranque en frío (deep link, id de evento editado a mano)
   * podía montar la pantalla y pedir los datos antes de que el rol persistido
   * estuviera leído, y el back — que sin `role` mantiene el comportamiento
   * viejo — devolvía toda la productora sin error visible.
   */
  {
    path: 'sales-manager-home',
    canActivate: [RoleReadyGuard],
    loadChildren: () => import('./modules/sales-manager-home/sales-manager-home.module').then(m => m.SalesManagerHomeModule)
  },

  /**
   * Dashboard Seller
   */
  {
    path: 'dashboard-seller',
    canActivate: [globalSellerContextGuard],
    loadChildren: () => import('./modules/dashboard-seller/dashboard-seller.module').then(m => m.DashboardSellerModule)
  },

  /**
   * Birthday
   */
  {
    path: 'birthdays',
    canActivate: [globalSellerContextGuard],
    loadChildren: () => import('./modules/birthday/birthday.module').then(m => m.BirthdayModule)
  },

  /**
   * App Version Admin
   */
  {
    path: 'app-version-admin',
    loadChildren: () => import('./modules/app-version-admin/app-version-admin.module').then(m => m.AppVersionAdminModule)
  },

  /**
   * Notification Center
   */

  /**
   * Inbox
   */
  {
    path: 'inbox',
    loadChildren: () => import('./modules/inbox/inbox.module').then(m => m.InboxModule)
  },

  /**
   * Turnstile Events List
   */
  {
    path: 'turnstile-events-list',
    loadChildren: () => import('./modules/turnstile-events-list/turnstile-events-list.module').then(m => m.TurnstileEventsListPageModule)
  },

  /**
   * Turnstile Monitor (Dashboard de evento específico)
   */
  {
    path: 'turnstile-monitor',
    loadChildren: () => import('./modules/turnstile-monitor/turnstile-monitor.module').then(m => m.TurnstileMonitorPageModule)
  },

  /**
   * Turnstile Management
   */
  {
    path: 'turnstile-management',
    loadChildren: () => import('./modules/turnstile-management/turnstile-management.module').then(m => m.TurnstileManagementModule)
  },

  /**
   * Administration
   */
  {
    path: 'administration',
    canActivate: [administrationContextGuard],
    loadChildren: () => import('./modules/administration/administration.module').then(m => m.AdministrationModule)
  },

  /**
   * Account
   */
  {
    path: 'account',
    loadChildren: () => import('./modules/account/account.module').then(m => m.AccountModule)
  },

  /**
   * Not Found 404
   */
  {
    path: '**',
    pathMatch: 'full',
    loadChildren: () => import('./modules/notfound/notfound.module').then(m => m.NotfoundPageModule)
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
